const types = {
  SET_ATTACHMENTS: 'SET_ATTACHMENTS',
}

export default types
